import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom'

import ModalVideo from 'react-modal-video';
import Lightbox from 'react-18-image-lightbox';
import Select from 'react-select';

import floor from '../assets/img/floor.jpg'
import image1 from '../assets/img/pl-6.jpg'
import user1 from '../assets/img/user-1.jpg'
import user5 from '../assets/img/user-5.jpg'
import edu from '../assets/img/edu.png'
import food from '../assets/img/food.png'
import { FaUser } from "react-icons/fa";
import { TfiEmail } from "react-icons/tfi";
import { FiPhone } from "react-icons/fi";

import { galleryImg, propertyFeature } from '../data/property'

import '../../node_modules/react-modal-video/css/modal-video.css'
import '../../node_modules/react-18-image-lightbox/style.css'

export default function PropertyDetail({ spaceDetails }: any) {
    const [isOpen, setIsOpen] = useState(false);
    let [open, setOpen] = useState<boolean>(true);
    let [open2, setOpen2] = useState<boolean>(false);
    let [open3, setOpen3] = useState<boolean>(true);
    let [open4, setOpen4] = useState<boolean>(false);
    let [open5, setOpen5] = useState<boolean>(false);
    let [open6, setOpen6] = useState<boolean>(false);
    let [open7, setOpen7] = useState<boolean>(false);
    let [open8, setOpen8] = useState<boolean>(true);
    let [open9, setOpen9] = useState<boolean>(true);
    let [open10, setOpen10] = useState<boolean>(true);
    let [show, setShow] = useState<boolean>(false);
    let [show2, setShow2] = useState<boolean>(false);
    let [show3, setShow3] = useState<boolean>(false);
    let [latitude, setLatitude] = useState<any>(null);
    let [longitude, setLongitude] = useState<any>(null);

    let [activeIndex, setActiveIndex] = useState<number>(0)
    let [photo, setPhoto] = useState<boolean>(false)

    const onImageClick = (index: number) => {
        setActiveIndex(index)
        setPhoto(true)
    }

    console.log("spaceDetails", spaceDetails);

    const rating = [
        { value: '1', label: '01 Star' },
        { value: '1', label: '02 Star' },
        { value: '1', label: '03 Star' },
        { value: '1', label: '04 Star' },
        { value: '1', label: '05 Star' },
    ]

    // const googleMapsUrl = `https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10000!2d${spaceDetails?.longitude}!3d${spaceDetails?.latitude}!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2z!5e0!3m2!1sen!2sin!4v1680238790732`;
    const googleMapsUrl = `https://www.google.com/maps?q=${spaceDetails?.latitude},${spaceDetails?.longitude}&hl=es;z=14&output=embed`;


    console.log("googleMapsUrl", googleMapsUrl);
    const defaultProps = {
        center: {
            lat: spaceDetails?.latitude,
            lng: spaceDetails?.longitude
        },
        zoom: 11
    };

    console.log("defaultProps", defaultProps);

    const AnyReactComponent = ({ text }: any) => <div>{text}</div>;

    return (
        <>
            <div className="property_block_wrap style-2">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen(!open)} className={open ? '' : 'collapsed'}><h4 className="property_block_title">Contact {spaceDetails?.user_type}</h4></Link>
                </div>
                <div id="clOne" className={`panel-collapse collapse ${open ? 'show' : ''}`}>
                    <div className="block-body">
                        <ul className="deatil_features">
                            {spaceDetails?.user_name && <div className="listing-card-info-icon" style={{ fontSize: 15 }}>
                                <div className="inc-fleat-icon me-1"><FaUser /></div>{spaceDetails?.user_name}
                            </div>}
                            {spaceDetails?.user_phoneno && <div className="listing-card-info-icon" style={{ fontSize: 15 }}>
                                <div className="inc-fleat-icon me-1"><FiPhone /></div>{spaceDetails?.user_phoneno}
                            </div>}
                            {spaceDetails?.user_email && <div className="listing-card-info-icon" style={{ fontSize: 15 }}>
                                <div className="inc-fleat-icon me-1"><TfiEmail /></div>{spaceDetails?.user_email}
                            </div>}
                            {/* {propertyFeature.map((item: any, index: number) => {
                                return (
                                    <li key={index}><strong>{item.title}</strong>{item.value}</li>
                                )
                            })} */}
                        </ul>
                    </div>
                </div>

            </div>

            <div className="property_block_wrap style-2">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen2(!open2)} className={open2 ? '' : 'collapsed'}><h4 className="property_block_title">Description</h4></Link>
                </div>
                <div id="clTwo" className={`panel-collapse collapse ${open2 ? 'show' : ''}`}>
                    <div className="block-body">
                        <p>{spaceDetails?.space_description ? spaceDetails?.space_description : "No Description Available"}</p>
                        {/* <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo.</p> */}
                    </div>
                </div>
            </div>

            {/* <div className="property_block_wrap style-2">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen4(!open4)} className={open4 ? '' : 'collapsed'}><h4 className="property_block_title">Property video</h4></Link>
                </div>

                <div id="clFour" className={`panel-collapse collapse ${open4 ? 'show' : ''}`}>
                    <div className="block-body">
                        <div className="property_video">
                            <div className="thumb">
                                <img className="pro_img img-fluid w100" src={image1} alt="7.jpg" />
                                <div className="overlay_icon">
                                    <div className="bb-video-box">
                                        <div className="bb-video-box-inner">
                                            <div className="bb-video-box-innerup">
                                                <Link to="#" onClick={() => setIsOpen(true)} className="text-primary"><i className="fa-solid fa-play"></i></Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalVideo
                    channel="youtube"
                    youtube={{ mute: 0, autoplay: 0 }}
                    isOpen={isOpen}
                    videoId="yba7hPeTSjk"
                    onClose={() => setIsOpen(false)}
                />

            </div> */}

            {/* <div className="property_block_wrap style-2">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen5(!open5)} className={open5 ? '' : 'collapsed'}><h4 className="property_block_title">Floor Plan</h4></Link>
                </div>
                <div id="clFive" className={`panel-collapse collapse ${open5 ? 'show' : ''}`}>
                    <div className="block-body">
                        <div className="accordion" id="floor-option">
                            <div className="card">
                                <div className="card-header" id="firstFloor">
                                    <h2 className="mb-0">
                                        <button type="button" onClick={() => setShow(!show)} className={`btn btn-link ${show ? '' : 'collapsed'}`} >First Floor<span>740 sq ft</span></button>
                                    </h2>
                                </div>
                                <div id="firstfloor" className={`collapse ${show ? 'show' : ''}`}>
                                    <div className="card-body">
                                        <img src={floor} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="seconfFloor">
                                    <h2 className="mb-0">
                                        <button type="button" onClick={() => setShow2(!show2)} className={`btn btn-link ${show2 ? '' : 'collapsed'}`}>Second Floor<span>710 sq ft</span></button>
                                    </h2>
                                </div>
                                <div id="secondfloor" className={`collapse ${show2 ? 'show' : ''}`}>
                                    <div className="card-body">
                                        <img src={floor} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="third-garage">
                                    <h2 className="mb-0">
                                        <button type="button" onClick={() => setShow3(!show3)} className={`btn btn-link ${show3 ? '' : 'collapsed'}`}>Garage<span>520 sq ft</span></button>
                                    </h2>
                                </div>
                                <div id="garages" className={`collapse ${show3 ? 'show' : ''}`}>
                                    <div className="card-body">
                                        <img src={floor} className="img-fluid" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            <div className="property_block_wrap style-2">
                <div className="property_block_wrap_header">
                    <Link to="#" onClick={() => setOpen6(!open6)} className={open6 ? '' : 'collapsed'}><h4 className="property_block_title">Location</h4></Link>
                </div>
                <div id="clSix" className={`panel-collapse collapse ${open6 ? 'show' : ''}`}>
                    <div className="block-body">
                        <div className="map-container">
                            <iframe
                                src={googleMapsUrl}
                                width="100%"
                                height="450"
                                style={{ border: '0' }}
                                loading="lazy"
                                title='myframe'
                            >

                            </iframe>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
